<template>
  <hr />
  <div class="events-home my-4" :class="{ 'events-home--rtl': isRtl, 'events-home--ltr': !isRtl }">
    <div
      class="d-flex justify-content-between align-items-center mb-3 section-header"
    >
      <h3 class="fw-bold text-dark mb-0" style="font-weight: 650 !important">
        <i class="fas fa-calendar-alt section-icon"></i>
        {{ $t("sch.events.upcoming") }}
      </h3>
      <div class="d-flex gap-2">
        <router-link
          to="/events-favorites"
          class="btn btn-sm btn-pill section-btn section-btn--favorites"
        >
          <i class="fa fa-heart me-1"></i>
          {{ $t("favorites.title") || "المفضلة" }}
        </router-link>
        <button
          class="btn btn-sm btn-pill section-btn section-btn--viewall"
          @click="viewAllEvents"
        >
          {{ $t("sch.events.view_all") }}
          <i :class="['fa', isRtl ? 'fa-arrow-left' : 'fa-arrow-right', 'ms-1', 'icon-shift']"></i>
        </button>
      </div>
    </div>

    <div class="row g-3">
      <div
        v-for="event in events"
        :key="event.id"
        class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex align-items-stretch"
      >
        <div
          class="card shadow-sm rounded-3 border-0 event-card w-100 hover-card"
        >
          <div class="event-img-wrapper">
            <img
              :src="getEventImage(event)"
              class="card-img-top event-image"
              alt="Event Image"
              @error="event.image = defaultImage"
            />
          </div>

          <div class="card-body d-flex flex-column p-2 p-md-3">
            <h5 class="card-title fw-bold text-success mb-2 small event-title">
              <i class="fas fa-bullhorn me-1"></i>
              {{ event.name_ar || event.name }}
            </h5>

            <p class="card-text text-muted mb-1 smaller chipline">
              <span class="chip"
                ><i class="fas fa-calendar-alt me-1"></i
                >{{ formatDate(event.date.start) }}</span
              >
            </p>

            <p
              v-if="event.place && (event.place.city || event.place.country)"
              class="card-text text-muted mb-2 smaller chipline"
            >
              <span class="chip chip-outline"
                ><i class="fas fa-map-marker-alt me-1"></i
                >{{ event.place.city || ""
                }}<span v-if="event.place.country"
                  >، {{ event.place.country }}</span
                ></span
              >
            </p>

            <div class="mt-auto text-end">
              <button
                class="btn btn-success btn-sm hover-btn btn-pill"
                @click="goToEvent(event.id)"
              >
                <i class="fas fa-info-circle me-1"></i>
                {{ $t("sch.events.view_details") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!events.length" class="text-center text-muted py-5">
      {{ $t("sch.events.empty") }}
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  name: "eventsHome",
  data() {
    return {
      events: [],
      defaultImage: "/assets/img/acad-icon.png",
    };
  },
  computed: {
    isRtl() {
      return this.$i18n.locale === "ar";
    },
  },
  async mounted() {
    await this.fetchEvents();
  },
  methods: {
    goToEvent(id) {
      window.location.href = `/event-details?id=${id}`;
    },
    viewAllEvents() {
      window.location.href = "/events-all";
    },
    async fetchEvents() {
      try {
        const response = await fetch(`${apiUrl}/events`, {
          method: "GET",
          headers: {
            "x-country-code": window.appRegion?.phone_code || "LY",
          },
        });
        const jsonResponse = await response.json();
        this.events = jsonResponse.data || [];
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    },
    getEventImage(event) {
      return event.image
        ? event.image.startsWith("http")
          ? event.image
          : `${apiUrl}${event.image}`
        : this.defaultImage;
    },
    formatDate(dateString) {
      if (!dateString) return "غير محدد";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
};
</script>

<style scoped>
/* RTL/LTR Support */
.events-home--rtl {
  direction: rtl;
}
.events-home--ltr {
  direction: ltr;
}

.events-home .event-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  background-color: #fff;
  border: 1px solid #eaf9f0;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.events-home .hover-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 28px rgba(0, 196, 68, 0.22);
}

.events-home .event-img-wrapper {
  width: 100%;
  height: 140px;
  overflow: hidden;
  border-bottom: 1px solid #eaf9f0;
}

.events-home .event-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.events-home .small {
  font-size: 0.85rem;
}

.events-home .smaller {
  font-size: 0.75rem;
}
.events-home .event-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 36px;
}
.events-home .chipline {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.events-home .chip {
  background: #eaf9f0;
  color: #0f5132;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 12px;
  border: 1px solid #c6ffda;
}
.events-home .chip-outline {
  background: #fff;
  color: #00a43c;
  border: 1px solid #00c44433;
}
.btn-success {
  background-color: #00c444 !important;
  border-color: #00c444 !important;
}
.btn-success:hover {
  background-color: #009e35 !important;
  border-color: #009e35 !important;
  box-shadow: 0 8px 18px rgba(0, 196, 68, 0.25);
}
.events-home .hover-btn {
  transition: all 0.3s;
}

.events-home .hover-btn:hover {
  background-color: #00c444;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 196, 68, 0.3);
}

/* Match index.vue header styles */
.section-header {
  background: linear-gradient(135deg, #f0fff5 0%, #e8fff1 50%, #ffffff 100%);
  border: 1px solid rgba(0, 196, 68, 0.15);
  border-radius: 20px;
  padding: 16px 22px;
  position: relative;
  overflow: hidden;
}
.section-header::before {
  content: "";
  position: absolute;
  top: 0;
  width: 120px;
  height: 120px;
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.08) 0%,
    transparent 70%
  );
  border-radius: 50%;
}
.events-home--rtl .section-header::before {
  right: 0;
  left: auto;
  transform: translate(30%, -30%);
}
.events-home--ltr .section-header::before {
  left: 0;
  right: auto;
  transform: translate(-30%, -30%);
}

/* Unified Section Icon Style */
.section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: linear-gradient(135deg, #e8fff1 0%, #c6ffda 100%);
  color: #00c444 !important;
  font-size: 16px;
  border: 2px solid rgba(0, 196, 68, 0.25);
  box-shadow: 0 6px 20px rgba(0, 196, 68, 0.25);
  transition: all 0.3s ease;
}
.events-home--rtl .section-icon {
  margin-left: 10px;
}
.events-home--ltr .section-icon {
  margin-right: 10px;
}
.section-icon:hover {
  transform: scale(1.1) rotate(-5deg);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.35);
}
.viewall-btn .icon-shift {
  transition: transform 0.25s ease;
}
.viewall-btn:hover .icon-shift {
  transform: translateX(-4px);
}

/* تحسين عرض البطاقات على الشاشات الصغيرة */
@media (max-width: 576px) {
  .events-home .event-img-wrapper {
    height: 120px;
  }
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] .events-home,
[data-theme="dark"] .events-home,
.dark .events-home {
  color: #e4e6eb;
}

/* Section Header Dark Mode */
[data-bs-theme="dark"] .events-home .section-header,
[data-theme="dark"] .events-home .section-header,
.dark .events-home .section-header {
  background: linear-gradient(135deg, #1a2e23 0%, #1e3a2c 50%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.25);
}

[data-bs-theme="dark"] .events-home .section-header h3,
[data-theme="dark"] .events-home .section-header h3,
.dark .events-home .section-header h3 {
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .events-home .section-icon,
[data-theme="dark"] .events-home .section-icon,
.dark .events-home .section-icon {
  background: linear-gradient(135deg, #1a3d2a 0%, #1e4d35 100%) !important;
  border-color: rgba(0, 196, 68, 0.4) !important;
  color: #00e050 !important;
  box-shadow: 0 8px 20px rgba(0, 196, 68, 0.35);
}

/* Event Card Dark Mode */
[data-bs-theme="dark"] .events-home .event-card,
[data-theme="dark"] .events-home .event-card,
.dark .events-home .event-card {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%) !important;
  border-color: rgba(0, 196, 68, 0.15) !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
}

[data-bs-theme="dark"] .events-home .hover-card:hover,
[data-theme="dark"] .events-home .hover-card:hover,
.dark .events-home .hover-card:hover {
  box-shadow: 0 14px 28px rgba(0, 196, 68, 0.25);
  border-color: rgba(0, 196, 68, 0.3) !important;
}

/* Event Image Wrapper Dark Mode */
[data-bs-theme="dark"] .events-home .event-img-wrapper,
[data-theme="dark"] .events-home .event-img-wrapper,
.dark .events-home .event-img-wrapper {
  border-color: rgba(0, 196, 68, 0.2) !important;
}

/* Card Body Dark Mode */
[data-bs-theme="dark"] .events-home .card-body,
[data-theme="dark"] .events-home .card-body,
.dark .events-home .card-body {
  background: transparent;
}

/* Event Title Dark Mode */
[data-bs-theme="dark"] .events-home .event-title,
[data-theme="dark"] .events-home .event-title,
.dark .events-home .event-title {
  color: #00e050 !important;
}

/* Card Text Dark Mode */
[data-bs-theme="dark"] .events-home .card-text,
[data-theme="dark"] .events-home .card-text,
.dark .events-home .card-text {
  color: #b0b3b8 !important;
}

/* Chips Dark Mode */
[data-bs-theme="dark"] .events-home .chip,
[data-theme="dark"] .events-home .chip,
.dark .events-home .chip {
  background: linear-gradient(135deg, #1a3d2a 0%, #1e4d35 100%);
  color: #8bffb3;
  border-color: rgba(0, 196, 68, 0.35);
}

[data-bs-theme="dark"] .events-home .chip-outline,
[data-theme="dark"] .events-home .chip-outline,
.dark .events-home .chip-outline {
  background: rgba(36, 37, 38, 0.9);
  color: #00e050;
  border-color: rgba(0, 196, 68, 0.4);
}

/* Button Dark Mode */
[data-bs-theme="dark"] .events-home .btn-outline-success,
[data-theme="dark"] .events-home .btn-outline-success,
.dark .events-home .btn-outline-success {
  border-color: #00e050 !important;
  color: #00e050 !important;
}

[data-bs-theme="dark"] .events-home .btn-outline-success:hover,
[data-theme="dark"] .events-home .btn-outline-success:hover,
.dark .events-home .btn-outline-success:hover {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  color: #fff !important;
}

[data-bs-theme="dark"] .events-home .btn-success,
[data-theme="dark"] .events-home .btn-success,
.dark .events-home .btn-success {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.35);
}

[data-bs-theme="dark"] .events-home .btn-success:hover,
[data-theme="dark"] .events-home .btn-success:hover,
.dark .events-home .btn-success:hover {
  box-shadow: 0 8px 20px rgba(0, 196, 68, 0.45);
}

/* Empty State Dark Mode */
[data-bs-theme="dark"] .events-home .text-muted,
[data-theme="dark"] .events-home .text-muted,
.dark .events-home .text-muted {
  color: #8b8d91 !important;
}

/* HR Dark Mode */
[data-bs-theme="dark"] hr,
[data-theme="dark"] hr,
.dark hr {
  border-color: rgba(0, 196, 68, 0.2);
  opacity: 0.5;
}

/* ========== Unified Section Buttons ========== */
.section-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.875rem;
  color: #fff !important;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.section-btn i,
.section-btn .fa,
.section-btn .fas,
.section-btn .far {
  color: #fff !important;
}

.section-btn:hover {
  transform: translateY(-3px);
  color: #fff !important;
}

.section-btn:hover i,
.section-btn:hover .fa,
.section-btn:hover .fas,
.section-btn:hover .far {
  color: #fff !important;
}

/* Favorites Button - Red/Pink gradient */
.section-btn--favorites {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  box-shadow: 0 4px 15px rgba(238, 90, 90, 0.35);
}

.section-btn--favorites:hover {
  background: linear-gradient(135deg, #ff5252 0%, #e53935 100%);
  box-shadow: 0 8px 25px rgba(238, 90, 90, 0.45);
}

/* View All Button - Green gradient */
.section-btn--viewall {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.35);
}

.section-btn--viewall:hover {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.45);
}

/* View all icon hover animation */
.section-btn--viewall .icon-shift {
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.events-home--rtl .section-btn--viewall:hover .icon-shift {
  transform: translateX(-6px);
}
.events-home--ltr .section-btn--viewall:hover .icon-shift {
  transform: translateX(6px);
}
</style>
